const REGEX = /^([0-1]?[0-9]|2[0-4]):([0-5][0-9])(:[0-5][0-9])?$/;

export default function isTimeValid(arg: string | undefined = "") {
  return REGEX.test(arg);
}
